/**
 * Pixel da Meta na pagina de sucesso do checkout (spec 013, item 4), como no checkout do sistema antigo: carrega o
 * `fbevents.js`, manda PageView e Purchase com o `eventID` que o servidor tambem manda pela API de conversoes. A Meta
 * junta os dois e conta uma compra. O servico so devolve o rastreio quando o pixel esta ligado no ambiente.
 */
import type { RastreioDaCompra } from "@mtc/contratos";
import { useEffect } from "react";

type Fbq = ((...args: unknown[]) => void) & { callMethod?: (...args: unknown[]) => void; queue: unknown[]; push: Fbq; loaded: boolean; version: string };
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

const disparados = new Set<string>();

/** O mesmo arranque do snippet oficial: a fila guarda as chamadas ate o script chegar. */
function carregar(pixelId: string): Fbq {
  if (window.fbq) return window.fbq;
  const fbq = ((...args: unknown[]) => (fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args))) as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  fbq("init", pixelId);
  return fbq;
}

export function usePixelDaCompra(r: RastreioDaCompra | null | undefined): void {
  useEffect(() => {
    if (!r || disparados.has(r.evento_id)) return;
    disparados.add(r.evento_id);
    const fbq = carregar(r.pixel_id);
    fbq("track", "PageView");
    fbq("track", "Purchase", { value: r.valor, currency: r.moeda, content_ids: r.conteudo_ids, content_name: r.conteudo_nome, content_type: "product", order_id: r.pedido, purchase_kind: "INITIAL_PURCHASE" }, { eventID: r.evento_id });
  }, [r]);
}
